import { render, staticRenderFns } from "./ChatGptPage.vue?vue&type=template&id=60479ebc&scoped=true&"
import script from "./ChatGptPage.vue?vue&type=script&lang=js&"
export * from "./ChatGptPage.vue?vue&type=script&lang=js&"
import style0 from "./ChatGptPage.vue?vue&type=style&index=0&id=60479ebc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60479ebc",
  null
  
)

/* custom blocks */
import block0 from "./ChatGptPage.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports